import AV from 'leancloud-storage'

export const user = {
  state: {
    user: null,
    openId: null
  },
  mutations: {
    logIn(state, user) {
      if (typeof user === 'object') {
        state.user = user
      } else {
        throw new TypeError('user is not a object [vuex]')
      }
    },

    logOut(state) {
      state.user = null
    },

    updateUserDesc(state, desc) {
      state.user.desc = desc
    },

    updateUsername(state, username) {
      state.user.username = username
    },

    updateOpenId(state, openId) {
      state.openId = openId
    }
  },
  actions: {
    async fetchUser({ state, commit }) {
      if (!state.user) {
        return
      }

      let avUser = AV.Object.createWithoutData("_User", state.user.objectId);
      await avUser.fetch();

      commit('logIn', avUser.toJSON())
    }
  },
  getters: {
    user: state => state.user,
    openId: state => state.openId,
    shouldFillInfo: (state) => {
      return Boolean(!state.user
        || !state.user.gender
        || !state.user.province
        || !state.user.city
        || !state.user.region
        || !state.user.mobilePhoneNumber)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js